import React from 'react';
import { X, Plus } from 'lucide-react';

export default function StopsEditor({ stops, onChange }) {
  const [draft, setDraft] = React.useState('');

  const add = () => {
    const v = draft.trim();
    if (!v) return;
    onChange([...stops, v]);
    setDraft('');
  };

  const remove = (idx) => {
    const next = stops.filter((_, i) => i !== idx);
    onChange(next);
  };

  return (
    <div>
      <label className="text-xs block mb-1.5" style={{ color: 'var(--lf-muted)' }}>
        Intermediate stops <span style={{ color: '#94a3b8' }}>(optional)</span>
      </label>
      <div className="flex flex-wrap items-center gap-2 mb-2">
        {stops.map((s, i) => (
          <span
            key={`${s}-${i}`}
            className="inline-flex items-center gap-1.5 text-xs font-semibold px-2 py-1 rounded-full"
            style={{ background: '#fff7ed', color: '#b45309', border: '1px solid #fed7aa' }}
          >
            <b className="text-[10px]" style={{ color: '#92400e' }}>#{i + 1}</b>
            {s}
            <button
              type="button"
              onClick={() => remove(i)}
              className="ml-0.5"
              style={{ background: 'transparent', border: 'none', cursor: 'pointer', color: '#b45309' }}
              aria-label="Remove stop"
            >
              <X size={12} />
            </button>
          </span>
        ))}
        {stops.length === 0 && (
          <span className="text-xs" style={{ color: '#94a3b8' }}>
            No stops added
          </span>
        )}
      </div>
      <div className="flex gap-2">
        <input
          value={draft}
          onChange={(e) => setDraft(e.target.value)}
          onKeyDown={(e) => {
            if (e.key === 'Enter') {
              e.preventDefault();
              add();
            }
          }}
          placeholder="e.g., Columbia, SC"
          className="flex-1 px-3 py-2.5 rounded-lg text-sm bg-white outline-none"
          style={{ border: '1px solid #d8dde6' }}
        />
        <button
          type="button"
          onClick={add}
          className="inline-flex items-center gap-1 px-3 py-2 rounded-lg text-sm font-semibold"
          style={{
            background: '#eef2f7',
            color: '#344054',
            border: 'none',
            cursor: 'pointer',
          }}
        >
          <Plus size={14} /> Add stop
        </button>
      </div>
    </div>
  );
}
